import axiosInstance from "./axiosInstance";

// Fetch branches, use /superadmin/branches for superadmin users
export const fetchBranches = (customer_id, isSuperadmin = false) => {
    const token = sessionStorage.getItem("token");
    const backendUrl = process.env.REACT_APP_API_URL;
    const params = customer_id ? { customer_id } : {};
    const url = `${backendUrl}/api/${isSuperadmin ? "superadmin" : "admin"}/branches`;
    return axiosInstance.get(url, {
        params,
        headers: { Authorization: `Bearer ${token}` }
    });
};
// Use /superadmin/branches for superadmin users
export const createBranch = (data, isSuperadmin = false) =>
    axiosInstance.post(`${isSuperadmin ? "/superadmin" : "/admin"}/branches`, data);
export const editBranch = (id, data, isSuperadmin = false) =>
    axiosInstance.put(`${isSuperadmin ? "/superadmin" : "/admin"}/branches/${id}`, data);
export const deleteBranch = (id, isSuperadmin = false) =>
    axiosInstance.delete(`${isSuperadmin ? "/superadmin" : "/admin"}/branches/${id}`);
